module.exports = __webpack_public_path__ + "static/chamaedorea-elegans-34bf65e8a397bff202c251970151bb85.svg";